import { render, staticRenderFns } from "./EventAddress.vue?vue&type=template&id=9921576e&scoped=true&"
import script from "./EventAddress.vue?vue&type=script&lang=js&"
export * from "./EventAddress.vue?vue&type=script&lang=js&"
import style0 from "./EventAddress.vue?vue&type=style&index=0&id=9921576e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921576e",
  null
  
)

export default component.exports